import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const startChatAction = createAsyncAction(
  '@chat/START_CHAT_REQUEST',
  '@chat/START_CHAT_SUCCESS',
  '@chat/START_CHAT_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingStartChat: true
})

const success = (state: ChatState, action: ActionType<typeof startChatAction.success>): ChatState => {
  const { updatedChatData } = action.payload

  return {
    ...state,
    activeChat: { ...state.activeChat, ...updatedChatData },
    isSuccessOnStartChat: true,
    isLoadingStartChat: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingStartChat: false,
  isErrorOnStartChat: true
})

export const startChatHandle = { asyncAction: startChatAction, request, success, failure }
